/** @jsxImportSource @emotion/react */

'use client';
import type { ReactNode } from 'react';

import Text from '../Text';
import * as styles from './styles';

interface BadgeProps {
  color?: styles.Color;
  circular?: boolean;
  children?: ReactNode;
}

export default function Badge({ color = 'lightGrey', circular, children = null }: BadgeProps) {
  return (
    <div css={[styles.badge, circular && styles.badgeCircular, styles.color(color)]}>
      <Text
        component="div"
        size="xsmall"
      >
        {children}
      </Text>
    </div>
  );
}
